import styled from 'styled-components';

import {
  Text,
  Flex,
} from 'web-styled';

export const Search = styled(Flex).attrs({
  flex: '0 0 68px',
  align: 'center',
})`
  width: 100%;
  padding: 0 15px;

  & > div {
    width: 100%;
  }
`;

export const Header = styled(Flex).attrs({
  align: 'center',
  spacing: 10,
  justify: 'space-between',
})`
  width: 100%;
  padding: 0 15px 4px;
  border-bottom: 1px solid #e9eaea;
`;

export const Item = styled(Flex).attrs({
  width: '100%',
  shrink: 0,
})`
  border-bottom: 1px solid #e9eaea;

  &:first-of-type {
    border-top: 1px solid #e9eaea;
  }

  .actions {
    visibility: hidden;
  }

  &:hover {
    background: #fbfbfb;

    .actions {
      visibility: visible;
    }
  }
`;

export const HeaderName = styled(Text)`
  font-size: 14px;
  color: #c4c4c4;
  text-align: left;
`;

export const Status = styled.div`
  color: #fff;
  font-size: 13px;
  text-align: center;
  text-transform: capitalize;
  border-radius: 4px;
  padding: 1px 5px;
  width: 50px;

  ${(props) => {
    switch (props.status) {
      case 'opened':
        return `
          background-color: ${props.theme.colors.primary};
        `;
      case 'paid':
        return `
          background-color: ${props.theme.colors.success};
        `;
      case 'void':
        return `
          background-color: ${props.theme.colors.warning};
        `;
      case 'deleted':
        return `
          background-color: ${props.theme.colors.danger};
        `;
      case 'uncollectible':
        return `
          background-color: ${props.theme.colors.darkDanger};
        `;
      default:
        return `
          background-color: #cdcdcd;
        `;
    }
  }}
`;
